import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Hero.css';

// HD royalty-free images from Pexels CDN — load directly in browser
const slides = [
  {
    tag: 'Trusted Since 2017 · Rajgurunagar, Pune',
    heading: 'Reliable Manpower &',
    heading2: 'Industrial Workforce',
    sub: 'Providing Skilled, Semi-Skilled & Unskilled Workforce across Chakan, Talegaon & Bhosari MIDC.',
    img: 'https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
    imgAlt: 'Industrial workers on factory floor',
  },
  {
    tag: 'Serving 15+ Industries Across Pune MIDC',
    heading: 'Professional Housekeeping',
    heading2: '& Facility Management',
    sub: 'Expert housekeeping teams, industrial cleaning, gardening and facility services — keeping your plant spotless.',
    img: 'https://images.pexels.com/photos/4239031/pexels-photo-4239031.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
    imgAlt: 'Professional housekeeping and cleaning staff',
  },
  {
    tag: '500+ Trained Workforce · Zero Compliance Risk',
    heading: 'Fast Deployment.',
    heading2: 'Full Legal Compliance.',
    sub: 'PF, ESI & Gratuity fully managed. Mobilize 500+ trained workers within 24–48 hours. On-site supervisors included.',
    img: 'https://images.pexels.com/photos/3862632/pexels-photo-3862632.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
    imgAlt: 'Team of industrial workers in safety gear',
  },
];

const STATS = [
  ['500+', 'Trained Workforce'],
  ['15+',  'Companies Served'],
  ['9+',   'Years Experience'],
  ['24/7', 'Support'],
];

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev]       = useState(null);
  const [transitioning, setTransitioning] = useState(false);
  const timerRef = useRef(null);

  const goTo = useCallback((idx) => {
    if (transitioning || idx === current) return;
    setTransitioning(true);
    setPrev(current);
    setCurrent(idx);
    setTimeout(() => { setPrev(null); setTransitioning(false); }, 700);
  }, [current, transitioning]);

  const next = useCallback(() => goTo((current + 1) % slides.length), [current, goTo]);
  const prevSlide = () => goTo((current - 1 + slides.length) % slides.length);

  const resetTimer = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(next, 5500);
  }, [next]);

  useEffect(() => {
    resetTimer();
    return () => clearInterval(timerRef.current);
  }, [resetTimer]);

  const handleArrow = (fn) => { fn(); resetTimer(); };
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="hero-slider" id="home">

      {/* Slide layers */}
      {slides.map((s, i) => (
        <div
          key={i}
          className={`slide-layer ${
            i === current ? 'active' :
            i === prev    ? 'leaving' : ''
          }`}
          style={{ backgroundImage: `url(${s.img})` }}
          aria-hidden={i !== current}
        />
      ))}

      {/* Dark overlay */}
      <div className="slide-overlay" />

      {/* Content */}
      <div className={`container slide-content ${transitioning ? 'slide-out' : 'slide-in'}`}>
        <div className="slide-tag">
          <span className="tag-dot" />
          {slides[current].tag}
        </div>
        <h1>
          {slides[current].heading}<br />
          <span>{slides[current].heading2}</span>
        </h1>
        <p className="slide-sub">{slides[current].sub}</p>
        <div className="slide-btns">
          <button className="btn-red" onClick={() => scrollTo('contact')}>Get Free Quote</button>
          <a href="tel:+919689100663" className="btn-outline-white">📞 +91 96891 00663</a>
        </div>
      </div>

      {/* Arrows */}
      <button className="slider-arrow left"  onClick={() => handleArrow(prevSlide)} aria-label="Previous">&#8249;</button>
      <button className="slider-arrow right" onClick={() => handleArrow(next)}      aria-label="Next">&#8250;</button>

      {/* Dots */}
      <div className="slider-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === current ? 'active' : ''}`}
            onClick={() => { goTo(i); resetTimer(); }}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Stats strip */}
      <div className="stats-strip">
        <div className="container stats-inner">
          {STATS.map(([n, l]) => (
            <div className="stat-pill" key={l}>
              <span className="sn">{n}</span>
              <span className="sl">{l}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
